import reducer from '../utils/reducer'
import { ACTION_NAMES } from '../utils/actionConstants'

const initialState = {
  loading: true
}

export default reducer(initialState, {
  [ACTION_NAMES.EMPLOYEE.UNLOAD_EMPLOYEE]: (state, payload) => {
    return initialState
  },
  [ACTION_NAMES.EMPLOYEE.REQUEST_EMPLOYEE]: (state, employee) => {
    return state
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_EMPLOYEE]: (state, employee) => {
    return {
      ...employee,
      loading: false
    }
  },
  [ACTION_NAMES.EMPLOYEE.REQUEST_CHANGE_LANGUAGE]: (state, language) => {
    return {
      ...state,
      loading: true
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_CHANGE_LANGUAGE]: (employee, language) => {
    employee.language = language
    return {
      ...employee,
      language: language,
      loading: false
    }
  },
  [ACTION_NAMES.EMPLOYEE.REQUEST_CHANGE_BROKER]: (state) => {
    return {
      ...state,
      pendingRequest: true
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_CHANGE_BROKER]: (state, pending_broker) => {
    return {
      ...state,
      pending_broker: pending_broker,
      pendingRequest: false
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_CHANGE_BROKER_ERROR]: (state, payload) => {
    return {
      ...state,
      pendingRequest: false,
      error: payload.error,
      errorMessage: payload.errorMessage
    }
  },
  [ACTION_NAMES.EMPLOYEE.REQUEST_DOCUMENT]: (employee) => {
    return {
      ...employee,
      pendingRequest: true
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_DOCUMENT]: (employee, content) => {
    return {
      ...employee,
      pendingRequest: false
    }
  },
  [ACTION_NAMES.EMPLOYEE.REQUEST_DOWNLOAD_SUMMARY]: (employee) => ({
    ...employee,
    pendingRequest: true
  }),
  [ACTION_NAMES.EMPLOYEE.RECEIVE_DOWNLOAD_SUMMARY]: (employee) => ({
    ...employee,
    pendingRequest: false
  }),
  [ACTION_NAMES.EMPLOYEE.REQUEST_ACCEPT_AWARD]: (employee, award_id) => {
    return {
      ...employee,
      pendingRequest: true
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_ACCEPT_AWARD]: (employee, award_id) => {
    return {
      ...employee,
      awards: employee.awards.map((el) => {
        if (el.id !== award_id) {
          return el
        } else {
          return {
            ...el,
            acceptance_date: new Date().toISOString(),
            acceptance_status: {
              code: "A",
              name: "Accepted"
            }
          }
        }
      }),
      pendingRequest: false
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_ACCEPT_AWARD_ERROR]: (employee, payload) => {
    return {
      ...employee,
      pendingRequest: false,
      error: payload.error,
      errorMessage: payload.errorMessage
    }
  },
  [ACTION_NAMES.EMPLOYEE.REQUEST_CHANGE_TAX]: (employee, awards, vests, tax_rate, apply_future) => {
    return {
      ...employee,
      pendingRequest: true
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_CHANGE_TAX_ERROR]: (employee, payload) => {
    return {
      ...employee,
      pendingRequest: false,
      error: payload.error,
      errorMessage: payload.errorMessage
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_CHANGE_TAX]: (employee, params) => {
    // Updates the awards and vests' tax rates.
    if (params.awards.length > 0 || (params.vests.length > 0)) {
      employee.awards.forEach((award) => {
        // Updates the awards tax rates.
        if (params.awards.includes(award.id)) {
          award.fed_override_tax = params.tax_rate
        }
        // Updates the vests tax rates.
        if (params.vests.length > 0) {
          award.vests.forEach((vest) => {
            if (params.vests.includes(parseInt(vest.id))) {
              vest.fed_override_tax = params.tax_rate
            }
          })
        }
      })
    }

    return {
      ...employee,
      pendingRequest: false
    }
  },
  [ACTION_NAMES.EMPLOYEE.REQUEST_CHANGE_FRACTIONAL]: (employee, vests) => {
    return {
      ...employee,
      pendingRequest: true
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_CHANGE_FRACTIONAL_ERROR]: (employee, payload) => {
    return {
      ...employee,
      pendingRequest: false,
      error: payload.error,
      errorMessage: payload.errorMessage
    }
  },
  [ACTION_NAMES.EMPLOYEE.RECEIVE_CHANGE_FRACTIONAL]: (employee, params) => {
    // Updates the vests' fractional indicators.
    if (params.vests.length > 0) {
      employee.awards.forEach((award) => {
        // Updates the vests fractional indicators.
        if (params.vests.length > 0) {
          award.vests.forEach((vest) => {
            var found = params.vests.findIndex(pvest => pvest.id === vest.id);

            if (found > -1){
              vest.fractional_share_in = params.vests[found].fractionalShareIndicator
            }
          })
        }
      })
    }

    employee.fractional_share_in = params.employee.fractional_share_in

    return {
      ...employee,
      pendingRequest: false
    }
  },
})
